export default function appendPromisfiedScript(src) {
  return new Promise((resolve, reject) => {
    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    // this is to prevent any value from being passed into resolve
    // as needed by ensureRecurlyJs
    const resolveFunc = () => resolve();
    script.type = 'text/javascript';
    script.src = src;
    script.onerror = reject;
    script.onload = resolveFunc;
    // IE6, 7 and 8 only support an onreadystatechange handler to signify that
    // a script has loaded.
    //
    // Documentation:
    // - https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement#See_also
    // - https://pie.gd/test/script-link-events/
    script.onreadystatechange = resolveFunc;
    head.appendChild(script);
  });
}
